import { useDebugValue } from 'react'
import { useDocumentData } from 'react-firebase-hooks/firestore'
import firebase from 'firebase'

import useFirebase from './useFirebase'
import useAuthState from './useAuthState'

import { User } from '../../../types/RM'

export interface UseUserData {
  auth: firebase.User
  data: User
}

export default function useUser() {
  const firebase = useFirebase()
  const [auth, authLoading, authErr, updateAuth] = useAuthState()
  const [data, dataLoading, dataErr] = useDocumentData<User>(
    auth ? firebase.firestore().doc(`users/${auth.uid}`) : null,
  )

  const loading = authLoading || dataLoading || !data
  const error = authErr || dataErr
  const user: UseUserData = { auth, data }

  useDebugValue({ user, loading, error, updateAuth })

  return [user, loading, error, updateAuth] as const
}
